import filter from 'lodash/filter';
import find from 'lodash/find';
import first from 'lodash/first';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import { State, getState } from './applicationState';
import { getBreakpointName } from './breakpointUtils';
const getTopLevelAttribute = (property) => {
    const config = getState(State.config);
    const platformSuffix = getBreakpointName();
    const platform = platformSuffix ? `web-${platformSuffix}` : 'web';
    const adConfigArray = get(config, 'adConfig');
    const platformConfig = find(adConfigArray, (obj) => find(obj.platforms, (value) => value === platform)) ||
        find(adConfigArray, (obj) => find(obj.platforms, (value) => value === 'web'));
    return platformConfig[property];
};
const getDefinitionByName = (definitionName, name) => {
    const definitions = getTopLevelAttribute(definitionName);
    if (!isNil(definitions)) {
        return first(filter(definitions, ['name', name]));
    }
    return undefined;
};
const configUtils = {
    getSlotDefinition(slotName) {
        return getDefinitionByName('slots', slotName);
    },
    getFormatDefinition(formatName) {
        return getDefinitionByName('formats', formatName);
    },
    getScreenDefinition(screenName) {
        return getDefinitionByName('webScreens', screenName);
    },
    getFormatDefinitionsBySlotDefinition(slot) {
        const formats = [];
        if (slot?.formats) {
            forEach(slot.formats, (formatName) => {
                const format = this.getFormatDefinition(formatName);
                formats.push(format);
            });
        }
        return formats;
    },
    filterFormatDefinitionsByDimensions(formats, dimensions) {
        if (!dimensions) {
            return formats;
        }
        const filteredFormats = [];
        formats.forEach((format) => {
            const filteredDimensions = format.dimensions.filter((formatDimensions) => formatDimensions.join('x') === dimensions);
            if (filteredDimensions.length) {
                filteredFormats.push({ ...format, dimensions: filteredDimensions });
            }
        });
        return filteredFormats;
    },
    getFormatDefinitionsBySlotName(slotName) {
        const slot = this.getSlotDefinition(slotName);
        return this.getFormatDefinitionsBySlotDefinition(slot);
    },
    getGlobalRefreshRate() {
        return getTopLevelAttribute('refreshRate');
    },
    isValidSlotForScreen(slotName, screenName) {
        if (!slotName) {
            return false;
        }
        if (!screenName) {
            return true;
        }
        const screen = this.getScreenDefinition(screenName) ||
            this.getScreenDefinition('default');
        if (!screen) {
            return true;
        }
        let found = false;
        forEach(screen.slots, (screenSlotName) => {
            found = screenSlotName === slotName;
            return !found;
        });
        return found;
    },
};
export default configUtils;
